import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { saveScanRecord } from '../services/api'

const Transition = () => {
    const { appUrl, element } = useParams()
    const [searchParams] = useSearchParams()

    let appStore = searchParams.get("appStore")
    let playStore = searchParams.get("playStore")
    let accessToken = searchParams.get("access_token")
    let refreshToken = searchParams.get("refresh_token")

    let queryString = window.location.href.split("?")[1]
    


    // console.log(`iwayplus://${appUrl}/${element}?${queryString}`)  
    
    const increaseCount = async () => {
        await saveScanRecord({
            platform: navigator.platform,
            appId: (navigator.platform.includes("iPhone") || navigator.platform.includes("Mac")) ? appStore : playStore
        })
    }
    
    useEffect(() => {
        let protocol = appUrl.split("-")
        // if(appUrl.includes("ipfg-openapp")) {

        //     // alert(appUrl)
        //     window.location.assign(`ipfg://openapp?access_token=${accessToken}&refresh_token=${refreshToken}`)
        // }
        // else if(appUrl.includes("ipfg-auth")) {
        //     window.location.assign(`ipfg://auth?access_token=${accessToken}&refresh_token=${refreshToken}`)
        // }
        // else if(appUrl.includes("empower-auth")) {
        //     window.location.assign(`empower://auth?access_token=${accessToken}&refresh_token=${refreshToken}`)
        // }
        if(protocol?.length === 2) {
            if(accessToken && refreshToken) window.location.assign(`${protocol[0]}://${protocol[1]}?access_token=${accessToken}&refresh_token=${refreshToken}`)
            else window.location.assign(`${protocol[0]}://${protocol[1]}?${queryString}`)
        }
        else {
            window.location.assign(`iwayplus://${appUrl}/${element}?${queryString}`)
        }

        increaseCount()
        

        let appTimeout = setTimeout(() => {

            if(navigator.platform.includes("iPhone") || navigator.platform.includes("Mac")) window.location.assign(`https://apps.apple.com/in/app/${appStore}`)
            else window.location.assign(`https://play.google.com/store/apps/details?id=${playStore}`)

        }, 3000)

        return () => clearTimeout(appTimeout)

    }, [])

    return (
        // <div onClick={() => window.location.href = "https://www.google.com"} >hello from transition on  deeplink:- iwayplus://{appUrl}/landmark?bid={bid}&landmark={landmark} {navigator.platform}</div>
        <div>Please wait...</div>
    )
}

export default Transition